import type { FeatureFinishedTuning } from "@slot/game-shell";
import type { SpinePanelFadeTuning } from "@slot/presentation";

// Per-game FEATURE-FINISHED panel tuning VALUES — the ONLY file to edit to retune it. The shell's
// part (FeatureFinishedTuning: the arm delay, the music) is passed whole into
// FeatureFinishedPresenter (wired in createPresentation). The game's view (FeatureFinishedView) is
// SPINE-DRIVEN in SIMPLE mode (the total_win Spine owns that motion) and reads its fades from `anim`
// (SpinePanelFadeTuning): the dim's fade in / out (OFFER mode enters and exits at once) and the
// hint's.

export const FEATURE_FINISHED_TUNING: FeatureFinishedTuning & { anim: SpinePanelFadeTuning } = {
  armDelayMs: 800,
  music: {
    idleId: "music_feature_idle",
    finishedIntroId: "music_feature_finished_intro",
    loopId: "music_feature_free_spins",
    loopFadeMs: 1500,
    baseId: "music_base",
    // baseFadeMs omitted → engine default fade (matches prior behavior).
  },
  anim: {
    enterDurationSeconds: 0.35,
    exitDurationSeconds: 0.25,
    continueFadeInSeconds: 0.4,
    continueFadeOutSeconds: 0.2,
  },
};
